import { LiveAppProvider, useLiveApp } from './context/LiveAppContext';
import SimpleDashboard from './components/SimpleDashboard';
import { LoginForm } from './components/auth/LoginForm';
import { LiveStatusBar } from './components/live/LiveStatusBar';

function LiveAppContent() {
 const { authState, isLoading } = useLiveApp();

 if (isLoading) {
  return (
   <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
     <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
     <p className="text-gray-600">Loading your dashboard...</p>
    </div>
   </div>
  );
 }

 if (!authState.isAuthenticated) {
  return <LoginForm />;
 }

 return (
  <>
   <LiveStatusBar />
   <SimpleDashboard />
  </>
 );
}

function App() {
 return (
  <LiveAppProvider>
   <div className="App">
    <LiveAppContent />
   </div>
  </LiveAppProvider>
 );
}

export default App;